export default "__VITE_ASSET__f316772b__"